export const VerificationStatus = {
    DRAFT: "draft_verification",
    INCOMPLETE: "verification_incomplete",
    SUBMITTED: "verification_submitted",
    PENDING: "pending_verification",
    VERIFIED: "verified",
    FAILED: "verification_failed",
    EXPIRED: "verification_expired"
}

// `verification_submitted` sits between draft and pending: the record is submitted
// but has not been raised as a review task yet (happens when a lower tier is still
// pending — e.g. tier 1 pending_verification, tier 2 verification_submitted).
// For the client UI it behaves exactly like pending: locked, read-only, awaiting review.
export const PENDING_LIKE_STATUSES = [VerificationStatus.SUBMITTED, VerificationStatus.PENDING]

export const isPendingLikeStatus = (status) => PENDING_LIKE_STATUSES.includes(status)

export const VerificationStep = Object.freeze({
    Country: 0,
    Flow: 1,
    Tier: 2,
    Document: 3,
    DocumentGroup: 4,
    Form: 5,
    Status: 6,
});